/** Default MIME types allowed for all document classes (must stay aligned with document_class_policy). */
export const DEFAULT_ALLOWED_CONTENT_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/png",
  "image/jpeg",
  "message/rfc822",
  "application/vnd.ms-outlook",
];

/** Infer upload MIME when the browser leaves File.type empty (common for PDFs on Windows). */
const EXTENSION_MIME = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  heic: "image/heic",
  heif: "image/heic",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  eml: "message/rfc822",
  msg: "application/vnd.ms-outlook",
};

function extensionFromFilename(name) {
  const dot = (name || "").lastIndexOf(".");
  if (dot < 0) {
    return null;
  }
  return name.slice(dot + 1).toLowerCase();
}

export function resolveUploadContentType(file) {
  const name = (file && file.name) || "";
  const extMime = EXTENSION_MIME[extensionFromFilename(name)];

  // Windows often reports application/octet-stream (or empty) for pdf/msg even when the extension is known.
  if (extMime && (!file || !file.type || file.type === "application/octet-stream")) {
    return extMime;
  }
  if (file && file.type) {
    return file.type;
  }
  if (extMime) {
    return extMime;
  }
  return "application/octet-stream";
}
